const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Linkedin"
}, /*#__PURE__*/React.createElement("rect", {
  id: "back",
  width: 512,
  height: 512
}), /*#__PURE__*/React.createElement("g", {
  id: "Linkedin-2",
  "data-name": "Linkedin"
}, /*#__PURE__*/React.createElement("path", {
  d: "M116.3,207h59.47V398.16H116.3Zm29.75-95a34.45,34.45,0,1,1-34.47,34.45A34.46,34.46,0,0,1,146.05,112",
  fill: "#9FCC46"
}), /*#__PURE__*/React.createElement("path", {
  d: "M213,207h57v26.14h.81c7.92-15,27.31-30.88,56.21-30.88,60.16,0,71.28,39.59,71.28,91.07V398.16H338.9v-93c0-22.17-.38-50.69-30.87-50.69-30.92,0-35.63,24.16-35.63,49.1v94.55H213Z",
  fill: "#9FCC46"
})));
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0c425cb2.svg";
export { ForwardRef as ReactComponent };